<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
            <EmpenhoList :contrato="contrato" :status="status" :prefix="prefixSimple"
                @onDblClickEmpenhoSelect="empenhoSelect" />
        </b-modal>

        <lg-form-input-finder :disabled="disabled" :value="computedValue" @input="updateValue" fieldDescription="numero"
            :label="label" invalidFeedback="Empenho deve ser informado!" description="" @handleClean="handleClean"
            :error="error" :cols="cols">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
export default {
    components: { LgFormInputFinder, EmpenhoList: () => import("@/modules/almoxarifados/empenho/EmpenhoList.vue") },
    props: {
        id: {
            type: String,
            default: "LgFinderPageEmpenho"
        },
        contrato: {
            type: Object,
            default: null
        },
        status: {
            type: Object,
            default: null
        },

        prefix: Array,
        label: {
            type: String,
            default: "Empenho:"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        value: Object,
        cols: String,
        error: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            internalValue: this.value || {},
        };
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue;
            },
            set(newValue) {
                this.internalValue = newValue;
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Empenho"];
        },
        prefixSimple() {
            return [...this.prefix];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        updateValue(newValue) {
            this.computedValue = newValue;
            this.$emit("input", newValue);
        },
        handleClean() {
            this.computedValue = {};
            this.$emit("input", {});
            this.$bvModal.hide(this.id);

        },
        empenhoSelect(item) {
            this.computedValue = item;
            this.$emit("input", item);
            this.$bvModal.hide(this.id);
        },
    },
};
</script>
